const valueCards = [
  { icon: "ri-eye-line", title: "Нет скрытых комиссий", desc: "Каждая копейка отображается в таблице. Никаких неожиданных доплат при доставке." },
  { icon: "ri-shield-user-line", title: "Полный контроль заказа", desc: "Вы видите каждый этап: от покупки до упаковки и отправки." },
  { icon: "ri-table-line", title: "Прозрачная структура расходов", desc: "Все затраты разбиты по строкам: товар, доставка по Китаю, международная доставка, комиссия." },
  { icon: "ri-time-line", title: "Быстрое оформление", desc: "Один Spreadsheet — и ваш заказ у поставщика в течение нескольких часов." },
];

const audienceRows = [
  { user: "Новички", fit: "Да", note: "Пошаговая инструкция внутри таблицы" },
  { user: "Бизнес", fit: "Да", note: "Оптовые заказы и контроль бюджета" },
  { user: "Реселлеры", fit: "Да", note: "Маржинальность под контролем" },
  { user: "Разовые покупки", fit: "Частично", note: "Лучше для заказов от $100" },
];

export default function ContentSections() {
  return (
    <>
      {/* Why Spreadsheet works better */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
          <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
            <a href="#why-spreadsheet" id="why-spreadsheet">
              Почему Spreadsheet работает лучше
            </a>
          </h4>
          <p className="text-foreground-600 mb-8">
            4 причины, по которым Spreadsheet стал главным инструментом для покупок в Китае
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {valueCards.map((card) => (
              <div
                key={card.title}
                className="bg-white border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className={`${card.icon} text-xl`} />
                </div>
                <h5 className="text-base font-semibold text-foreground-900 font-heading mb-2">
                  {card.title}
                </h5>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who is it for */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
          <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">
            <a href="#audience" id="audience">
              Кому подходит YOYBUY Spreadsheet
            </a>
          </h4>
          <p className="text-foreground-600 mb-8">
            Независимо от вашего опыта, Spreadsheet делает покупки в Китае предсказуемыми
          </p>

          <div className="bg-white border border-background-200 rounded-lg overflow-hidden">
            <div className="grid grid-cols-3 gap-0">
              <div className="px-4 py-3 bg-secondary-50 text-sm font-semibold text-foreground-800 border-b border-background-200">
                Пользователь
              </div>
              <div className="px-4 py-3 bg-secondary-50 text-sm font-semibold text-foreground-800 border-b border-background-200">
                Подходит
              </div>
              <div className="px-4 py-3 bg-secondary-50 text-sm font-semibold text-foreground-800 border-b border-background-200">
                Примечание
              </div>
            </div>
            {audienceRows.map((row, idx) => (
              <div
                key={row.user}
                className={`grid grid-cols-3 gap-0 ${idx % 2 === 0 ? "bg-white" : "bg-background-50/50"}`}
              >
                <div className="px-4 py-3 text-sm text-foreground-800 border-b border-background-100">
                  {row.user}
                </div>
                <div className="px-4 py-3 text-sm font-medium text-primary-700 border-b border-background-100">
                  {row.fit}
                </div>
                <div className="px-4 py-3 text-sm text-foreground-600 border-b border-background-100">
                  {row.note}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why you lose money */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-4">
                <a href="#lose-money" id="lose-money">
                  Почему вы теряете деньги без Spreadsheet
                </a>
              </h4>
              <ul className="space-y-4 mb-6">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0 mt-0.5">
                    <i className="ri-close-line text-sm" />
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed">
                    <strong className="text-foreground-900">Посредники увеличивают цену</strong> — обычные агенты добавляют 10–25% к стоимости товара, которую вы никогда не увидите.
                  </p>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0 mt-0.5">
                    <i className="ri-close-line text-sm" />
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed">
                    <strong className="text-foreground-900">Нет прозрачности комиссии</strong> — скрытые сборы за хранение, фото, переупаковку накапливаются незаметно.
                  </p>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 shrink-0 mt-0.5">
                    <i className="ri-close-line text-sm" />
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed">
                    <strong className="text-foreground-900">Нет контроля закупки</strong> — вы не видите, когда агент купил товар, проверил ли его, отправил ли на склад.
                  </p>
                </li>
              </ul>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-block bg-accent-500 hover:bg-accent-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors"
              >
                Перестать терять деньги — перейти на Spreadsheet
              </a>
            </div>
            <div className="rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20stylized%20illustration%20of%20money%20flying%20away%20from%20open%20pocket%2C%20soft%20pastel%20colors%2C%20clean%20white%20cream%20background%2C%20abstract%20financial%20loss%20concept%2C%20editorial%20art%20style%2C%20gentle%20lighting%2C%20modern%20aesthetic%2C%20no%20text&width=800&height=600&seq=yoybuy-loss-01&orientation=landscape"
                alt="Financial loss without spreadsheet"
                className="w-full h-auto object-cover object-top"
                loading="lazy"
                width={800}
                height={600}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article CTA */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
          <div className="bg-white border border-background-200 rounded-lg p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="w-full md:w-1/3 rounded-lg overflow-hidden border border-background-200 shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20with%20golden%20coins%20stacked%20neatly%20and%20small%20calculator%20on%20soft%20cream%20background%2C%20clean%20editorial%20style%2C%20pastel%20warm%20colors%2C%20soft%20shadows%2C%20financial%20savings%20concept%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=yoybuy-value-01&orientation=landscape"
                alt="Savings concept"
                className="w-full h-48 md:h-auto object-cover object-top"
                loading="lazy"
                width={800}
                height={600}
              />
            </div>
            <div className="flex-1">
              <h4 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3">
                Полное руководство по YOYBUY Spreadsheet
              </h4>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6">
                Узнайте, как настроить Spreadsheet, сравнить агентов и сэкономить до 40% на каждой покупке в Китае. Пошаговая инструкция для новичков и опытных покупателей.
              </p>
              <a
                href="/article"
                className="inline-block bg-primary-500 hover:bg-primary-600 text-white font-medium px-6 py-3 rounded-md whitespace-nowrap transition-colors"
              >
                Читать руководство
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}